module.exports = __webpack_public_path__ + "img/ZB电表.35fd6090.jpg";